import React from 'react';
import { motion } from 'framer-motion';
export function Benefits() {
  return <section className="py-10 sm:py-16 px-4 bg-brand-sage-light border-y border-brand-sage/20" data-id="element-20">
      <div className="max-w-2xl mx-auto text-center" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-22">
          <span className="inline-block text-brand-olive font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 sm:mb-4" data-id="element-23">
            🍃 METODO MEDITERRANEO™
          </span>
          <h2 className="text-xl sm:text-4xl font-serif font-bold text-brand-text-main mb-4 sm:mb-6" data-id="element-24">
            Il primo sistema alimentare "Apri e Applica" ispirato alla
            tradizione mediterranea moderna.
          </h2>

          <div className="space-y-3 sm:space-y-4 text-sm sm:text-lg text-brand-text-muted font-medium max-w-lg mx-auto" data-id="element-25">
            <p data-id="element-26">Non è una dieta.</p>
            <p data-id="element-27">Non ti chiede di contare calorie.</p>
            <p data-id="element-28">Non ti fa sentire in colpa.</p>
            <p className="text-base sm:text-xl font-bold text-brand-olive mt-4 sm:mt-6" data-id="element-29">
              Ti dà un sistema che si adatta alla tua vita — non il contrario.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}